/* eslint-disable react/prop-types */
import "./ShowUserInfo.css";
import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { API_URL, custom_axios_post, STATIC_URL } from "./Common";
import styled from "@emotion/styled";
import Search from "@mui/icons-material/Search";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import GroupIcon from "@mui/icons-material/Group";
// import PersonIcon from "@mui/icons-material/Person";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
const StyledFlexibleDiv = styled("div")`
  display: flex;
`;
const StyledDivAccordion = styled("div")`
  background-color: ${(props) => props.theme.palette.primary.main};
  color: ${(props) => props.theme.palette.primary.contrastText};
  height: 39px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const StyledIconButton = styled(IconButton)`
  font-size: 14px;
  color: ${(props) => props.theme.palette.primary.contrastText};
`;

const StyledSearch = styled(Search)`
  color: ${(props) => props.theme.palette.primary.main};
`;

const StyledChip = styled(Chip)`
  margin-right: 5px;
  height: 15px;
  font-size: 8px;
`;
const StyledFlex = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: start;
`;
const StyledOptionFlex = styled("div")`
  display: flex;
  //flex-direction: column;
  align-items: start;
`;
const StyledDialogTitle = styled(DialogTitle)`
  color: ${(props) => props.theme.palette.primary.contrastText};
  background-color: ${(props) => props.theme.palette.primary.main};
  padding: 5px 10px;
`;
const StyledDialogContent = styled(DialogContent)`
  padding: 0px;
`;
function ShowForwardMessage({ openForwardMessage, handleClose, chatrooms }) {
  const getRoomName = (chatroom) => {
    //console.log("chatroomの名前", chatroom.roomname);
    if (chatroom.roomname !== "") {
      const solonum = chatroom.memberlist.length + 1;
      return chatroom.roomname + (solonum <= 2 ? "" : "(" + String(solonum) + ")");
    } else {
      //console.log("空っぽの場合", chatroom.memberlist);
      let roomname = "";
      for (let i = 0; i < chatroom.memberlist.length; i++) {
        roomname = roomname + chatroom.memberlist[i].name + ",";
        //console.log("chatroom.memberlist[i].name", chatroom.memberlist[i].name);
      }
      roomname = roomname.slice(0, -1);
      const groupnum = chatroom.memberlist.length + 1;
      return roomname + (groupnum === 2 ? "" : "(" + String(groupnum) + ")");
    }
  };
  const [groupRooms, setGroupRooms] = useState([]);
  const [contactRooms, setContactRooms] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const sortList = chatrooms.sort(function (a, b) {
      if (a.isstar < b.isstar) {
        return 1;
      }
      if (a.isstar > b.isstar) {
        return -1;
      }
      if (a.latestsending < b.latestsending) {
        return 1;
      }
      if (a.latestsending > b.latestsending) {
        return -1;
      }
      return 0;
    });

    setContactRooms(
      sortList
        .filter((f) => f.isgroup == 0 && f.ismyroom == 0 && f.parentroomid === f.roomid && f.ishide != "1")
        .map((m) => {
          return { ...m, isstar: "0" };
        })
    );
    setGroupRooms(
      sortList
        .filter(
          (f) => f.isgroup == 1 && f.isbotroom == 0 && f.ismyroom == 0 && f.parentroomid === f.roomid && f.ishide != "1"
        )
        .map((m) => {
          return { ...m, isstar: "0" };
        })
    );
  }, [openForwardMessage.messageid]);

  const sendServer = async () => {
    setLoading(true);
    const body = {
      messageid: openForwardMessage.messageid,
      roomids: [
        ...groupRooms.filter((f) => f.isstar == "1").map((v) => v.roomid),
        ...contactRooms.filter((f) => f.isstar == "1").map((v) => v.roomid),
      ],
      honbuid: localStorage.getItem("honbuid"),
    };
    await custom_axios_post(API_URL + "/forwardMessage", body);
    setLoading(false);
    handleClose();
  };
  const [chatsFilter, setChatsFilter] = useState("");
  const handleTextChange = (e) => {
    setChatsFilter(e.target.value);
  };
  const [groupexpanded, setGroupExpanded] = React.useState(true);
  const [expanded, setExpanded] = React.useState(true);
  return (
    <Dialog open={openForwardMessage.open} onClose={handleClose} maxWidth={"sm"}>
      <StyledDialogTitle id="max-width-dialog-title">
        <div className="show-member-search">
          転送先選択 (
          {groupRooms &&
            contactRooms &&
            (
              groupRooms.filter((f) => f.isstar == "1").length + contactRooms.filter((f) => f.isstar == "1").length
            ).toString()}
          )
          <div className="chat-search-member">
            <div className="chat-search-icon">
              <StyledSearch></StyledSearch>
              {/* <Search className={classes.iconcolor} /> */}
            </div>
            <input
              placeholder="検索"
              value={chatsFilter}
              name="chatsFilter"
              onChange={handleTextChange}
              className="chat-search-field"
            />
          </div>
        </div>
      </StyledDialogTitle>

      <StyledDialogContent>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "80vh",
          }}
        >
          <StyledDivAccordion onClick={() => setGroupExpanded(!groupexpanded)}>
            {/* <div className="ac-group-between"> */}
            <div className="ac-group" style={{ marginLeft: "6px", height: "40px" }}>
              <GroupIcon></GroupIcon>
              <div>グループ</div>
            </div>
            <StyledIconButton size={"small"}>{groupexpanded ? <FaAngleUp /> : <FaAngleDown />}</StyledIconButton>
            {/* </div> */}
          </StyledDivAccordion>
          <div style={{ display: groupexpanded ? "" : "none" }}>
            {groupRooms &&
              groupRooms.map((e) => {
                if (chatsFilter == "" || String(e.roomname).indexOf(chatsFilter) !== -1) {
                  return (
                    <div
                      key={e.roomid}
                      className="read-member-wrapper"
                      onClick={() => {
                        setGroupRooms((v) => {
                          return v.map((vv) => {
                            if (vv.roomid == e.roomid) {
                              return { ...vv, isstar: vv.isstar == "1" ? "0" : "1" };
                            } else {
                              return vv;
                            }
                          });
                        });
                      }}
                    >
                      <div className="read-member-content">
                        <div className="avatar-item">
                          <a>
                            <img
                              src={STATIC_URL + `/downloadRoomAvatar?roomid=${e.roomid}&fileno=${e.fileno}`}
                              width="32"
                              height="32"
                              alt=""
                              className="chat-image"
                              //style={isCurrent ? { border: "1px solid white" } : null}
                            />
                          </a>
                        </div>

                        <div className="chat-name-wrapper">
                          <div className="chat-name">
                            <StyledFlex>
                              <StyledOptionFlex>
                                {e.isofficial == "1" && (
                                  <StyledChip
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    label="人事連携"
                                  ></StyledChip>
                                )}
                                {e.isbukai == "1" && (
                                  <StyledChip variant="outlined" color="primary" size="small" label="部会"></StyledChip>
                                )}
                                {e.isdirection == "1" && (
                                  <StyledChip variant="outlined" size="small" label="一方向"></StyledChip>
                                )}
                              </StyledOptionFlex>
                              {getRoomName(e)}
                            </StyledFlex>
                          </div>
                        </div>
                      </div>
                      <FormControlLabel
                        control={<Checkbox checked={e.isstar === "1"} onChange={() => {}} name="checkedA" />}
                        // label="発言"
                      />
                    </div>
                  );
                }
              })}
          </div>
          <StyledDivAccordion onClick={() => setExpanded(!expanded)}>
            {/* <div className="ac-group-between"> */}
            <div className="ac-group" style={{ marginLeft: "6px", height: "40px" }}>
              <GroupIcon></GroupIcon>
              <div>コンタクト</div>
            </div>
            <StyledIconButton size={"small"}>{groupexpanded ? <FaAngleUp /> : <FaAngleDown />}</StyledIconButton>
            {/* </div> */}
          </StyledDivAccordion>
          <div style={{ display: expanded ? "" : "none" }}>
            {contactRooms &&
              contactRooms.map((e) => {
                if (chatsFilter == "" || String(e.roomname).indexOf(chatsFilter) !== -1) {
                  return (
                    <div
                      key={e.roomid}
                      className="read-member-wrapper"
                      onClick={() => {
                        setContactRooms((v) => {
                          return v.map((vv) => {
                            if (vv.roomid == e.roomid) {
                              return { ...vv, isstar: vv.isstar == "1" ? "0" : "1" };
                            } else {
                              return vv;
                            }
                          });
                        });
                      }}
                    >
                      <div className="read-member-content">
                        <div className="avatar-item">
                          <a>
                            <img
                              src={
                                STATIC_URL +
                                (e.memberlist.length > 1 || e.isofficial == 1
                                  ? `/downloadRoomAvatar?roomid=${e.roomid}&fileno=${e.fileno}`
                                  : e.memberlist.length == 0
                                    ? `/downloadRoomAvatar?roomid=${e.roomid}&fileno=${e.fileno}`
                                    : `/downloadAvatar?honbuid=${e.memberlist[0].honbuid}&size=small`)
                              }
                              width="32"
                              height="32"
                              alt=""
                              className="chat-image"
                              //style={isCurrent ? { border: "1px solid white" } : null}
                            />
                          </a>
                        </div>

                        <div className="chat-name-wrapper">
                          <div className="chat-name">
                            <StyledFlexibleDiv>
                              {e.memberlist[0].isvip == "1" && (
                                <StyledChip variant="outlined" color="primary" size="small" label="VIP"></StyledChip>
                              )}
                              {e.memberlist[0].isbukaiadmin == "1" ? (
                                <StyledChip
                                  variant="outlined"
                                  color="primary"
                                  size="small"
                                  label="部会管理"
                                ></StyledChip>
                              ) : (
                                <div></div>
                              )}
                              {e.memberlist[0].isadmin == "1" ? (
                                <StyledChip
                                  variant="outlined"
                                  color="primary"
                                  size="small"
                                  label="システム管理"
                                ></StyledChip>
                              ) : e.memberlist[0].isadmin == "2" ? (
                                <StyledChip
                                  variant="outlined"
                                  color="primary"
                                  size="small"
                                  label="施設管理"
                                ></StyledChip>
                              ) : e.memberlist[0].isadmin == "3" ? (
                                <StyledChip
                                  variant="outlined"
                                  color="primary"
                                  size="small"
                                  label="部屋管理"
                                ></StyledChip>
                              ) : e.memberlist[0].isadmin == "6" ? (
                                <StyledChip
                                  variant="outlined"
                                  color="primary"
                                  size="small"
                                  label="施設横断部屋"
                                ></StyledChip>
                              ) : e.memberlist[0].isadmin == "4" ? (
                                <StyledChip
                                  variant="outlined"
                                  color="primary"
                                  size="small"
                                  label="ユーザー管理"
                                ></StyledChip>
                              ) : e.memberlist[0].isadmin == "5" ? (
                                <StyledChip
                                  variant="outlined"
                                  color="primary"
                                  size="small"
                                  label="部屋・ユーザー管理"
                                ></StyledChip>
                              ) : (
                                <div></div>
                              )}
                            </StyledFlexibleDiv>
                            {getRoomName(e)}
                            <span style={{ fontSize: "80%", marginLeft: "5px" }}>({e.memberlist[0].subname})</span>
                          </div>
                        </div>
                      </div>
                      <FormControlLabel
                        control={<Checkbox checked={e.isstar === "1"} onChange={() => {}} name="checkedA" />}
                        // label="発言"
                      />
                    </div>
                  );
                }
              })}
          </div>
        </div>
      </StyledDialogContent>

      <DialogActions>
        <Button
          onClick={sendServer}
          disabled={
            loading
              ? true
              : groupRooms.filter((r) => r.isstar == "1").length > 0 ||
                  contactRooms.filter((r) => r.isstar == "1").length > 0
                ? false
                : true
          }
          variant={
            loading
              ? "outlined"
              : groupRooms.filter((r) => r.isstar == "1").length > 0 ||
                  contactRooms.filter((r) => r.isstar == "1").length > 0
                ? "contained"
                : "outlined"
          }
          color="primary"
        >
          {loading ? "転送中..." : "転送"}
        </Button>
        <Button onClick={handleClose} variant="outlined" color="primary">
          キャンセル
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ShowForwardMessage;
